"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayWalletState = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm");
let MangopayWalletState = class MangopayWalletState {
    _id;
    walletId;
    updatedAt = new Date();
    walletCreationDate = new Date();
    ownerIds;
    balanceAmount;
    balanceCurrency;
    ownerUserId;
};
exports.MangopayWalletState = MangopayWalletState;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayWalletState.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumberString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayWalletState.prototype, "walletId", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)(({ value }) => new Date(value)),
    __metadata("design:type", Date)
], MangopayWalletState.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)(({ value }) => new Date(value)),
    __metadata("design:type", Date)
], MangopayWalletState.prototype, "walletCreationDate", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayWalletState.prototype, "ownerIds", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], MangopayWalletState.prototype, "balanceAmount", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], MangopayWalletState.prototype, "balanceCurrency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayWalletState.prototype, "ownerUserId", void 0);
exports.MangopayWalletState = MangopayWalletState = __decorate([
    (0, typeorm_1.Entity)("mangopayWalletStates")
], MangopayWalletState);
//# sourceMappingURL=MangopayWalletState.js.map